import { render, staticRenderFns } from "./BackgroundMenu.vue?vue&type=template&id=6de28bbc&scoped=true&"
import script from "./BackgroundMenu.vue?vue&type=script&lang=js&"
export * from "./BackgroundMenu.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundMenu.vue?vue&type=style&index=0&id=6de28bbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de28bbc",
  null
  
)

export default component.exports